export default __webpack_public_path__ + "static/media/qrmaster-screenshot-04.1070bec5.png";